import { render, staticRenderFns } from "./AddSinglePin.vue?vue&type=template&id=460a127d&scoped=true"
import script from "./AddSinglePin.vue?vue&type=script&lang=js"
export * from "./AddSinglePin.vue?vue&type=script&lang=js"
import style0 from "./AddSinglePin.vue?vue&type=style&index=0&id=460a127d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a127d",
  null
  
)

export default component.exports